import { render, staticRenderFns } from "./CampusEditModal.vue?vue&type=template&id=db778534&scoped=true&"
import script from "./CampusEditModal.vue?vue&type=script&lang=ts&"
export * from "./CampusEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db778534",
  null
  
)

export default component.exports